<div class="a-titulo">
    CONSULTA INTEGRAL
</div>
<div class="a-w1-column">
    <form [formGroup]="group" class="a-w1-row">
        <div class="a-w1 a-w1-row">
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select [options]="ListaFechaReferencia" optionLabel="nombre" formControlName="fechareferencia"
                        optionValue="codigo" appendTo="body" styleClass="w-full md:w-full" inputId="float-label">
                    </p-select>
                    <label for="float-label">Fecha Referencia</label>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-datepicker class="a-w1" formControlName="desde" [dateFormat]="'dd/mm/yy'" [showIcon]="true"
                        styleClass="w-full md:w-full" inputId="float-label"></p-datepicker>
                    <label htmlFor="username">Fecha Desde</label>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-datepicker class="a-w1" formControlName="hasta" [dateFormat]="'dd/mm/yy'" [showIcon]="true"
                        styleClass="w-full md:w-full" inputId="float-label"></p-datepicker>
                    <label htmlFor="username">Fecha Hasta</label>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select [options]="ListaTodosLineaNegocio" optionLabel="nombre" formControlName="lineanegocio"
                        optionValue="codigo" appendTo="body" styleClass="w-full md:w-full" inputId="float-label">
                    </p-select>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input formControlName="nrocrm" type="text" pInputText inputId="float-label" />
                    <label for="float-label">Nro. CRM</label>
                </p-floatlabel>
            </div>
            <div style="display: flex; gap: 20px;">
                <p-button icon="pi pi-search" label="Buscar" (onClick)="search()"></p-button>
                <p-button icon="pi pi-file-excel" label="Exportar" (onClick)="exportExcel()"></p-button>
            </div>
        </div>
    </form>
</div>
<app-datatable [metadataTable]="metadataTable" [dataTable]="dataTable" [filterGlobal]="true"></app-datatable>